import { render } from "./ContractsPage.vue?vue&type=template&id=0752880b&scoped=true"
import script from "./ContractsPage.vue?vue&type=script&lang=js"
export * from "./ContractsPage.vue?vue&type=script&lang=js"

import "./ContractsPage.vue?vue&type=style&index=0&id=0752880b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0752880b"]])

export default __exports__